import { Capacitor } from '@capacitor/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

const isNative = Capacitor.isNativePlatform();

export const crashlytics = {
    async initialize() {
        if (!isNative) return;
        await FirebaseCrashlytics.setEnabled({ enabled: true });
    },

    async setUserId(userId) {
        if (!isNative) return;
        await FirebaseCrashlytics.setUserId({ userId });
    },

    async log(message) {
        if (!isNative) return;
        await FirebaseCrashlytics.log({ message });
    },

    async recordException(message) {
        if (!isNative) return;
        await FirebaseCrashlytics.recordException({ message });
    },

    async setCustomKey(key, value) {
        if (!isNative) return;
        await FirebaseCrashlytics.setCustomKey({ key, value: String(value) });
    },
};
